import React, { useState, useEffect } from "react";
import axios from 'axios';

import Grid from './components/Grid.js';
import NovaLista from './components/NovaLista.js';
import NovoCartao from './components/NovoCartao.js';
import EditarCartao from './components/EditarCartao.js';
import GridQuadroProprios from './components/GridQuadrosProprios.js';
import GridQuadroTerceiro from './components/GridQuadrosTerceiro.js';
import GridQuadroGeral from './components/GridQuadrosGeral.js';
import NovoQuadro from './components/Novoquadro.js';
import Compartilhar from './components/Compartilhar.js';
import NovaTarefa from './components/NovaTarefa.js';
import InfTarefa from './components/InfoTarefa.js';
import MoverCartao from './components/MoverCartao.js';
import EditarNomeLista from './components/EditarNomeDaLista.js';
import EditarQuadro from './components/EditarQuadro.js';
import DashboardVideos from './components/dashboard-video.js';



import logo1 from "../../../styles/imagem/logo-1.png";
import logo2 from "../../../styles/imagem/logo-2.png";
import logo3 from "../../../styles/imagem/logo-3.png";
import logo4 from "../../../styles/imagem/logo-4.png";
import logo5 from "../../../styles/imagem/logo-5.png";

import { SlSizeFullscreen } from "react-icons/sl";
import GlobalStyle from "../../../styles/global2.js";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import { toast, ToastContainer } from "react-toastify";
//import imagemTutorial from "../../../styles/imagem/tutorial.jpg";
import './style.css';
import { FaEye } from "react-icons/fa";

import { IoMdArrowBack } from "react-icons/io";
import { IoClose } from "react-icons/io5";
import { FaVideo } from "react-icons/fa";
//import Swal from "sweetalert2";

import fundo2 from "../../../styles/fundo2.svg";
import fundo from "../../../styles/fundo.svg";

const Geral = styled.div` 
  width: 100vw;
  background-image: url(${fundo2});
`;

const DivGrid = styled.div` 
  height: calc(100vh - 4rem);
  overflow-y: auto;
  overflow-x: hidden;
`;
const Div = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center; 
  width: 100%;
  align-items: center;

  h2 {
    color: #fff;
  }
`;

const Div2 = styled.div`

`;

const Title = styled.nav`
  width: 100%;
  display: flex;
  justify-content: space-between; 
  align-items: center;
  height: 4rem;
  background-image: url(${fundo}); 
`;

const Title2 = styled.h2`
  display: flex;
  justify-content: space-between; 
  align-items: center;
  width: 100%;
  font-size: 28px;
  height: 40%;
`;




const ButtonContainer = styled.div`
  display: flex;
  justify-content: start; 
`;

const ButtonClose = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  border: none;
  background-color: transparent;
  transition: transform 0.3s;
  z-index: 1;

  &:hover {
    transform: scale(1.5);
  }
`;



const ButtonSair = styled.button`
  padding: 10px 20px 0px 20px;
  cursor: pointer;
  border-radius: 3px;
  border: none;
  background-color: transparent;
  color: #fff;
  font-weight: bold;
  font-size: 24px;
  margin: 5px;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.2);
  }

`;
const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
    border-radius: 10px;
  
`;
const ModalContent = styled.div`
  position: relative; /* necessário para posicionar absolutos internos */
  background-image: url(${fundo2});
  padding: 40px 20px 20px 20px; /* espaço no topo para o botão fixo */
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
  max-height: 90vh;
  overflow-y: auto;
`;

const Button = styled.button`
  padding: 10px 20px 0px 20px;
  cursor: pointer;
  border-radius: 3px;
  border: none;
  background-color: transparent;
  color: #fff;
  font-weight: bold;
  font-size: 24px;
  margin: 5px;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.2);
  }

`;

const Button2 = styled.button`
  padding: 10px 20px 0px 20px;
  cursor: pointer;
  border-radius: 3px;
  border: none;
  background-color: transparent;
  color: #575757;
  font-weight: bold;
  font-size: 24px;
  margin: 5px;
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.2);
  }

`;


function App() {

  //---------------------------------------------------------------------------------------------------------------//
  //Ip's da api e do front
  const urlFront = process.env.REACT_APP_FRONT_URL;
  const urlApi = process.env.REACT_APP_API_URL;

  //---------------------------------------------------------------------------------------------------------------//

  //Token da api
  const token = localStorage.getItem('token');
  const id = parseInt(localStorage.getItem('id'));

  //--------------------------------------------------BOTÂO DE VOLTAR-------------------------------------------------------------//

  const handleVoltar = () => {
    window.location.href = urlFront;
  };

  //---------------------------------------------------------------------------------------------------------------//

  //Verifica o token do usuário
  const [tToken, setToken] = useState("");
  const getToken = async () => {
    try {
      const res = await axios.get(`${urlApi}logon/token`, { headers: { Authorization: `Bearer ${token}` } });
      setToken(res.data);
    } catch (error) {
      if (error.response && (error.response.status === 400 || error.response.status === 403 || error.response.status === 401)) {
        window.location.href = `${urlFront}login`;
      } else {
        console.error("Erro ao obter token:", error);
      }
    }

  };

  useEffect(() => {
    getToken()
  }, []);


  //--------------------------------------------FUNÇÂO QUE RECEBE OS USUÀRIOS------------------------------------//
  const [usuario, setUsuarios] = useState([]);


  const fetchUsuarios = async () => {
    try {
      const res = await axios.get(`${urlApi}portal/listar-usuarios`, { headers: { Authorization: `Bearer ${token}` } });
      setUsuarios(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de usuarios:', error);
    }
  };



  useEffect(() => {
    fetchUsuarios();
  }, [token]);

  //-----------------------------------------------VERIFICA SE O USUÀRIO È ADMIN-------------------------------//

  const [acessos, setAcessos] = useState([]);

  useEffect(() => {
    const fetchAcessos = async () => {
      try {
        const res = await axios.post(`${urlApi}portal/acessos-portal`,
          { id },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        const painelAccess = Array.isArray(res.data)
          ? res.data.find((acesso) => acesso.COD_MODULO === 3)
          : null;

        setAcessos(painelAccess);
      } catch (error) {
        console.error('Erro ao buscar dados de acessos:', error);
      }
    };

    fetchAcessos();
  }, [token]);


  const [mostrarQuadroGeral, setMostrarQuadroGeral] = useState(false);

  // verifica se o usuário tem acesso ao painel
  const temAcesso = acessos && (acessos.TIPO_ACESSO === "A");

  //----------------------------------------------RECEBE OS QUADROS-----------------------------------------------------------------//

  const [quadro, setQuadro] = useState([]);
  const fetchQuadro = async () => {
    try {
      const res = await axios.post(`${urlApi}painel-monitoramento/meus-quadros`, { id }, { headers: { Authorization: `Bearer ${token}` } });

      setQuadro(res.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {

        setQuadro([]);
      } else {
        console.error('Erro ao buscar dados de quadro:', error);
      };
    }
  };


  useEffect(() => {
    fetchQuadro();
  }, [token]);

  //----------------------------------------------RECEBE OS QUADROS COMPARTILHADOS-----------------------------------------------------------------//

  const [quadroCompartilhados, setQuadroCompartilhados] = useState([]);
  const fetchQuadroCompartilhados = async () => {
    try {
      const res = await axios.post(`${urlApi}painel-monitoramento/quadros-compartilhados`, { id }, { headers: { Authorization: `Bearer ${token}` } });

      setQuadroCompartilhados(res.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {

        setQuadroCompartilhados([]);
      } else {
        console.error('Erro ao buscar dados de quadro:', error);
      };
    }
  };


  useEffect(() => {
    fetchQuadroCompartilhados();
  }, [token]);

  //----------------------------------------------RECEBE TODOS OS QUADROS/CARTOES-----------------------------------------------------------------//

  const [todosQuadros, setTodosQuadros] = useState([]);
  const [todosCartoes, setTodosCartoes] = useState([]);

  const fetchTodosQuadros = async () => {
    try {
      const res = await axios.post(`${urlApi}painel-monitoramento/todos-quadros`, { id }, { headers: { Authorization: `Bearer ${token}` } });

      setTodosQuadros(res.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {

        setTodosQuadros([]);
      } else {
        console.error('Erro ao buscar dados de quadro:', error);
      }

    }
  };
  const fetchTodosCartoes = async () => {
    try {
      const res = await axios.get(`${urlApi}painel-monitoramento/todos-cartao`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTodosCartoes(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de card:', error);
    }
  };



  useEffect(() => {
    fetchTodosQuadros();
    fetchTodosCartoes();
  }, [mostrarQuadroGeral]);



  //----------------------------------------------RECEBE OS VISUALIZADORES-----------------------------------------------------------------//

  const [visualizador, setCompartilhamento] = useState([]);

  const fetchCompartilhamento = async () => {
    try {
      const res = await axios.get(`${urlApi}painel-monitoramento/ver-quadros-compartilhados`, { headers: { Authorization: `Bearer ${token}` } });
      setCompartilhamento(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados do compartilhamento:', error);
    }
  };


  useEffect(() => {
    fetchCompartilhamento();
  }, [token]);









  //---------------------------------------------------------------------------------------------------------------//
  /*
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title:
          "O Painel de Monitoramento agora conta com um tutorial passo a passo. Clique no ícone de câmera ou em 'Abrir tutorial' para conferir.",
        text: "Confira as informações abaixo.",
        imageUrl: imagemTutorial, // URL da imagem
        imageWidth: 100, // Largura da imagem
        imageAlt: "Imagem de exemplo", // Texto alternativo
        html: `
          <div style="text-align: left; margin-top: 10px; color: #3a3f42;">
            <input type="checkbox" id="doNotShowAgain" style="margin-right: 8px;">
            <label for="doNotShowAgain">Não mostrar novamente</label>
          </div>
        `,
        showCancelButton: true,
        confirmButtonText: "Abrir tutorial",
        cancelButtonText: "Fechar",
        customClass: {
          container: "custom-swal-container", // Estiliza o container principal
          title: "custom-swal-title", // Estiliza o título
          confirmButton: "custom-swal-confirm-button", // Estiliza o botão de confirmação
          cancelButton: "custom-swal-cancel-button", // Estiliza o botão de cancelamento
          popup: "custom-swal-popup", // Estiliza o popup
          icon: "custom-swal-icon", // Estiliza o ícone
        },
        preConfirm: () => {
          // Captura o estado do checkbox antes de confirmar
          const checkbox = document.getElementById("doNotShowAgain");
          if (checkbox && checkbox.checked) {
            localStorage.setItem("popupDismissed", "true"); // Salva no localStorage
          }
          return true; // Retorna confirmação
        },
      }).then((result) => {
        if (result.isConfirmed) {
          resolve(true); // Usuário confirmou
        } else {
          resolve(false); // Usuário fechou
        }
      });
    });
  };


  // Exemplo de uso
  useEffect(() => {
    const isPopupDismissed = localStorage.getItem("popupDismissed");
    if (!isPopupDismissed) {
      showPopUp().then((confirmed) => {
        if (confirmed) {
          // Chama o modal tutorial
          modalVideo();
        }
      });
    }
  }, []);
  */







  //---------------------------------------------------------------------------------------------------------------//


  const [isModalOpen, setIsModalOpen] = useState(false);
  const modalNovaColuna = () => {
    setIsModalOpen(!isModalOpen);

  };

  //Abre o modal 'Novo cartão'
  const [novoCard, setNovoCard] = useState(false); //Recebe o valor da coluna, passa para o NovoCard criar o cartão
  const [isModalOpenCard, setIsModalOpenCard] = useState(false);
  const modalNovoCard = (coluna) => {
    setIsModalOpenCard(!isModalOpenCard);
    setNovoCard(coluna)
  };

  //Abre o modal 'Editar cardo'
  const [editarCartao, setEditarCartao] = useState(false);

  const [isModalOpenEditarCartao, setIsModalOpenEditarCartao] = useState(false);
  const modalEditarCartao = (card) => {
    setIsModalOpenEditarCartao(!isModalOpenEditarCartao); // Corrigido para alternar o estado corretamente
    setEditarCartao(card); // Atualiza o card para editar, ou null para limpar ao fechar
    fetchCard();
  };

  //Abre o modal 'Novo quadro'
  const [isModalOpenQuadro, setIsModalOpenQuadro] = useState(false);
  const modalNovoQuadro = () => {
    setIsModalOpenQuadro(!isModalOpenQuadro);

  };

  //Abre o modal 'Compartilhar'
  const [isModalOpenCompartilhar, setIsModalOpenCompartilhar] = useState(false);
  const modalCompartilhar = () => {
    setIsModalOpenCompartilhar(!isModalOpenCompartilhar);
  };

  //Abre nova tarefa
  const [isModalOpenTarefa, setIsModalOpenTarefa] = useState(false);
  const modalNovaTarefa = () => {
    setIsModalOpenTarefa(!isModalOpenTarefa);
  };

  //modal mover tarefa
  const [isModalOpenMover, setIsModalOpenMover] = useState(false);
  const modalMover = () => {
    setIsModalOpenMover(!isModalOpenMover); // Corrigido para alternar o estado corretamente

  };
  //modal editar nome da lista
  const [editarNomeLista, setEditarNomeLista] = useState(false);
  const [isModalOpenEditarNomeLista, setIsModalOpenEditarNomeLista] = useState(false);
  const modalEditarNomeLista = (coluna) => {
    setIsModalOpenEditarNomeLista(!isModalOpenEditarNomeLista); // Corrigido para alternar o estado corretamente
    setEditarNomeLista(coluna);
    fetchColunas();
  };


  //State responsavel por mostrar o quadro que o usuário escolheu
  const [verQuadro, setVerQuadro] = useState(null);

  const [editarQuadro, setEditarQuadro] = useState(null);
  const [isModalOpenEditarQuadro, setIsModalOpenEditarQuadro] = useState(false);
  const modalVerQuadro = (quadro) => {
    setIsModalOpenEditarQuadro(!isModalOpenEditarQuadro); // Corrigido para alternar o estado corretamente
    fetchQuadro();
    fetchColunas();
    setEditarQuadro(quadro);
  };

  //---------------------------------------------------------------------------------------------------------------//


  // Verifica quem criou o chamado para liberar o botões
  const [criador, setCriador] = useState(null)
  useEffect(() => {
    if (verQuadro) {
      const criador = verQuadro.ID_CRIADOR === id;
      setCriador(criador);
    }
  }, [verQuadro]);


  //---------------------------------------------------------------------------------------------------------------//
  //Modal respondendo a tarefa
  //Abre o modal 'Informações da tarefa'
  const [infTarefa, setInfTarefa] = useState("")
  const [isModalOpenInfTarefa, setIsModalOpenInfTarefa] = useState(false);
  const modalInfTarefa = (check) => {
    setIsModalOpenInfTarefa(!isModalOpenInfTarefa);
    setInfTarefa(check)
  };





  //Modal que mostra as apresentações
  const [isModalOpenVideo, setIsModalOpenVideo] = useState(false);
  const modalVideo = () => {
    setIsModalOpenVideo(!isModalOpenVideo);
  };





  //----------------------------------------------RECEBE AS COLUNAS-----------------------------------------------------------------//

  const [colunas, setColunas] = useState([]);


  const fetchColunas = async () => {
    try {
      if (!verQuadro) return;

      const res = await axios.post(
        `${urlApi}painel-monitoramento/listas`,
        { id_quadro: verQuadro.ID_QUADRO },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setColunas(res.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {

        setColunas([]);
      } else {
        console.error('Erro ao buscar dados de colunas:', error);
      }
    }
  };




  //----------------------------------------------RECEBE OS CARD-----------------------------------------------------------------//

  const [card, setCard] = useState([]);


  const fetchCard = async () => {
    try {
      const res = await axios.post(`${urlApi}painel-monitoramento/cartao`, { id_quadro: verQuadro.ID_QUADRO }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCard(res.data);
    } catch (error) {
      console.error('Erro ao buscar dados de card:', error);
    }
  };




  useEffect(() => {
    if (verQuadro?.ID_QUADRO) {
      fetchColunas();
      fetchCard();
      fetchCompartilhamento();
    }
  }, [verQuadro]);



  //----------------------------------------------RECEBE OS CHECKS----------------------------------------------------------------//

  const [checkbox, setCheckbox] = useState([]);

  const fetchCheckbox = async () => {
    if (!editarCartao?.ID_CARTAO) return;

    try {
      const res = await axios.post(
        `${urlApi}painel-monitoramento/tarefas`,
        { id_cartao: editarCartao.ID_CARTAO },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCheckbox(res.data);
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setCheckbox([]);
      } else {
        console.error('Erro ao buscar dados de tarefas:', error);
      }
    }
  };



  useEffect(() => {
    if (editarCartao?.ID_CARTAO) {
      fetchCheckbox();
    }
  }, [editarCartao]);


  //----------------------------------------------RECEBE OS CHECKS----------------------------------------------------------------//

  const [anexos, setAnexos] = useState([]);
  const [anexosTarefa, setAnexosTarefa] = useState([]);

  const fetchAnexos = async () => {
    if (!editarCartao?.ID_CARTAO && !infTarefa?.ID_TAREFA) return;

    try {
      if (editarCartao?.ID_CARTAO) {
        const res = await axios.get(
          `${urlApi}painel-monitoramento/anexos?id_cartao=${editarCartao.ID_CARTAO}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAnexos(res.data);
      }

      if (infTarefa?.ID_TAREFA) {
        const res2 = await axios.get(
          `${urlApi}painel-monitoramento/anexos?id_tarefa=${infTarefa.ID_TAREFA}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setAnexosTarefa(res2.data);
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setCheckbox([]); // essa linha talvez esteja errada, não tem relação com anexos
      } else {
        console.error('Erro ao buscar dados de anexos:', error);
      }
    }
  };



  useEffect(() => {
    if (editarCartao || infTarefa) {
      fetchAnexos();
    }
  }, [editarCartao, infTarefa]);





  //-----------------------------------------CONTROLA O FULL SCREEN--------------------------//


  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen().catch((err) => {
        console.log(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
      });
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  //---------------------IMAGEM DE CARREGANDO-----------//
  const [abaAtiva, setAbaAtiva] = useState("");
  const [loadingImage, setLoadingImage] = useState(null);

  const imagens = [logo1, logo2, logo3, logo4, logo5];

  const trocarAbaComImagem = (novaAba) => {
    const imagemAleatoria = imagens[Math.floor(Math.random() * imagens.length)];
    setLoadingImage(imagemAleatoria);

    setTimeout(() => {
      setLoadingImage(null);
      setAbaAtiva(novaAba);
    }, 1000);
  };

  useEffect(() => {
    trocarAbaComImagem("painel"); // define o nome da aba ativa
  }, []);

  //---------------------------------------------------------------------------------------------------------------//

  const handleQuadro = () => {
    setVerQuadro(null);
    setEditarQuadro(null);
    setCheckbox(null);
    setIsModalOpenEditarQuadro(false);
  };

  return (
    <>
      {isModalOpenQuadro && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalNovoQuadro();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <NovoQuadro urlApi={urlApi} modalNovoQuadro={modalNovoQuadro} fetchQuadro={fetchQuadro} />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpen && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalNovaColuna();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <NovaLista urlApi={urlApi} modalNovaColuna={modalNovaColuna} fetchColunas={fetchColunas} verQuadro={verQuadro} />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenCard && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalNovoCard();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <NovoCartao urlApi={urlApi} modalNovoCard={modalNovoCard} novoCard={novoCard} fetchCard={fetchCard} usuario={usuario} visualizador={visualizador} quadro={quadro} />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenEditarCartao && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => modalEditarCartao()}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <EditarCartao
              urlApi={urlApi}
              card={card}
              modalEditarCartao={modalEditarCartao}
              fetchCard={fetchCard}
              usuario={usuario}
              editarCartao={editarCartao}
              checkbox={checkbox}
              fetchCheckbox={fetchCheckbox}
              modalNovaTarefa={modalNovaTarefa}
              modalInfTarefa={modalInfTarefa}
              infTarefa={infTarefa}
              modalMover={modalMover}
              visualizador={visualizador}
              anexos={anexos}
              verQuadro={verQuadro}
              fetchAnexos={fetchAnexos}
              anexosTarefa={anexosTarefa}
            />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenCompartilhar && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalCompartilhar();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <Compartilhar urlApi={urlApi} usuario={usuario} verQuadro={verQuadro} visualizador={visualizador} fetchCompartilhamento={fetchCompartilhamento} />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenTarefa && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalNovaTarefa();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <NovaTarefa urlApi={urlApi}
              modalEditarCartao={modalEditarCartao}
              fetchCard={fetchCard}
              usuario={usuario}
              editarCartao={editarCartao}
              checkbox={checkbox}
              fetchCheckbox={fetchCheckbox}
              modalNovaTarefa={modalNovaTarefa}
              visualizador={visualizador} verQuadro={verQuadro} />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenInfTarefa && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalInfTarefa();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <InfTarefa urlApi={urlApi} anexosTarefa={anexosTarefa} fetchAnexos={fetchAnexos} verQuadro={verQuadro} visualizador={visualizador} checkbox={checkbox} fetchCheckbox={fetchCheckbox} modalInfTarefa={modalInfTarefa} infTarefa={infTarefa} card={card} editarCartao={editarCartao} />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenMover && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => modalMover()}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <MoverCartao
              urlApi={urlApi}
              modalEditarCartao={modalEditarCartao}
              editarCartao={editarCartao}
              colunas={colunas}
              fetchColunas={fetchColunas}
              modalMover={modalMover}

            />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenEditarNomeLista && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => modalEditarNomeLista()}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <EditarNomeLista
              urlApi={urlApi}
              fetchColunas={fetchColunas}
              editarNomeLista={editarNomeLista}
              modalEditarNomeLista={modalEditarNomeLista}
            />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenEditarQuadro && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => modalVerQuadro()}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <EditarQuadro
              editarQuadro={editarQuadro}
              modalVerQuadro={modalVerQuadro}
              setVerQuadro={setVerQuadro}
              urlApi={urlApi}
              fetchQuadro={fetchQuadro}
            />
          </ModalContent>
        </ModalContainer>
      )}

      {isModalOpenVideo && (
        <ModalContainer>
          <ModalContent>
            <ButtonContainer>
              <ButtonClose onClick={() => {
                modalVideo();
              }}>
                <IoClose color={"red"} size={25} />
              </ButtonClose>
            </ButtonContainer>
            <DashboardVideos urlApi={urlApi} />
          </ModalContent>
        </ModalContainer>
      )}

      {loadingImage || abaAtiva === "" ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            width: "100%",
            textAlign: "center",
          }}
        >
          <img
            src={loadingImage}
            alt="Carregando..."
            style={{
              width: 600,
              height: "auto",
              animation: "zoomIn 0.8s ease-out forwards",
            }}
          />
          <style>
            {`
                  @keyframes zoomIn {
                    from {
                      opacity: 0;
                      transform: scale(0.8);
                    }
                    to {
                      opacity: 1;
                      transform: scale(1);
                    }
                  }
                `}
          </style>
        </div>
      ) : (
        <Geral>
          <Title>

            <Title2>

              <Div>
                {verQuadro ? (
                  <Button onClick={handleQuadro} title="Ver os quadros">
                    <IoMdArrowBack />
                  </Button>

                ) : (
                  <ButtonSair onClick={handleVoltar} title="Voltar para o portal">
                    <IoMdArrowBack />
                  </ButtonSair>
                )}
                {verQuadro ? (
                  <>                <Div>

                    <h2> {verQuadro.TITULO_QUADRO}</h2>


                  </Div>

                    <Button onClick={toggleFullscreen} title="Tela cheia" style={{ backgroundColor: "transparent" }}>

                      <SlSizeFullscreen />

                    </Button>
                  </>


                ) : (
                  <>
                    <Div>
                      <h2>Painel de Monitoramento</h2>
                    </Div>

                    <Button className="button-apresentacao" onClick={modalVideo} title={"Apresentação"}>
                      <FaVideo />
                    </Button>
                  </>
                )}


              </Div>

            </Title2>



          </Title>
          <DivGrid>
            {verQuadro ? (
              <Grid
                urlApi={urlApi}
                modalNovaColuna={modalNovaColuna}
                colunas={colunas}
                fetchColunas={fetchColunas}
                card={card}
                modalNovoQuadro={modalNovoQuadro}
                fetchCard={fetchCard}

                modalNovoCard={modalNovoCard}
                modalEditarCartao={modalEditarCartao}
                verQuadro={verQuadro}
                modalCompartilhar={modalCompartilhar}
                criador={criador}
                modalEditarNomeLista={modalEditarNomeLista}
                checkbox={checkbox}
                setVerQuadro={setVerQuadro}
              />
            ) : (
              <Div2>
                <GridQuadroProprios
                  urlApi={urlApi}
                  quadro={quadro}
                  modalNovoQuadro={modalNovoQuadro}
                  fetchQuadro={fetchQuadro}
                  setVerQuadro={setVerQuadro}
                  modalVerQuadro={modalVerQuadro}
                />

                <GridQuadroTerceiro
                  quadroCompartilhados={quadroCompartilhados}
                  setVerQuadro={setVerQuadro}
                />
                {temAcesso && (
                  <>
                    {/* Botão para mostrar ou esconder o Grid */}
                    <Button2 onClick={() => setMostrarQuadroGeral(!mostrarQuadroGeral)} title="Ver todos os quadros">
                      <FaEye size={20} />
                    </Button2>

                    {/* Grid exibido somente se o botão foi clicado */}
                    {mostrarQuadroGeral && (
                      <GridQuadroGeral
                        card={card}
                        setVerQuadro={setVerQuadro}
                        todosQuadros={todosQuadros}
                        todosCartoes={todosCartoes}
                      />
                    )}
                  </>
                )}

              </Div2>
            )}
          </DivGrid>

        </Geral >
      )}
      <GlobalStyle />
      <ToastContainer autoClose={2500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />
    </>
  );
}

export default App;
